import {
    FETCH_FABRIC_PROJECTION_REQUEST,
    FETCH_FABRIC_PROJECTION_SUCCESS,
    FETCH_FABRIC_PROJECTION_FAILURE,
    CREATE_FABRIC_PROJECTION_FORM,
    UPDATE_FABRIC_PROJECTION_FORM,
    CREATE_FABRIC_PROJECTION_SUCCESS,
    FETCH_SINGLE_FABRIC_PROJECTION_SUCCESS,
    UPDATE_FABRIC_PROJECTION_SUCCESS,
    DELETE_FABRIC_PROJECTION_SUCCESS,
    CREATE_FABRIC_PROJECTION_REQUEST,
    UPDATE_FABRIC_PROJECTION_REQUEST,
    FETCH_SINGLE_FABRIC_PROJECTION_REQUEST,
    DELETE_FABRIC_PROJECTION_REQUEST,
    RESET_FABRIC_PROJECTION_INFO,
    CREATE_FABRIC_PROJECTION_FAILURE,
    UPDATE_FABRIC_PROJECTION_FAILURE,
    FETCH_SINGLE_FABRIC_PROJECTION_FAILURE,
    DELETE_FABRIC_PROJECTION_FAILURE,
    FETCH_PRNO_REQUEST,
    FETCH_PRNO_SUCCESS,
    FETCH_PRNO_FAILURE,
    FETCH_COMBINED_SL_NO_SUCCESS,
    FETCH_COMBINED_SL_NO_FAILURE,
    FETCH_COMBINED_SL_NO_REQUEST,
    FETCH_FABRIC_PROJECTION_INVOICE_SUCCESS,
    FETCH_FABRIC_PROJECTION_INVOICE_FAILURE,
    FETCH_FABRIC_PROJECTION_INVOICE_REQUEST,
    //UPDATE_FLD_SUBJECT // subject validations 0407
} from './fabricProjection.actionsType';

export const FABRIC_PROJECTION = 'fabricProjection';

let initialState = {
    loading: false,
    fabricProjectionList: [],
    fabricProjectionForm: {
        // fldFKUnitId:'',
        // fldFKSupplierID: '',
        fldGroupPRNo:'',
        fldCombinedSlNo:'',
        fldFKMillName:'',
        //fldFKYarn:'',
        fldFKFabric:'',
        fldFKDia:'',
        fldFKLoopLength:'',
        fldFKGauge:'',
       // fldBagWeight:'',
       // fldNoofBags:'',
         fldPRWeight:'',
        fldRate:'',
        fldRemarks:'',
        fldGSM:'',
        fldFKAgentName:'',
        fldFKColor:'',
        fldFabric:'',
        fldColor:'',
        fldDia:'',
        fldLoopLegth:'',
        fldGauge:'',
        fldFabricDescription:''

    },
    selectedState: {},
    errorMessage: '',
    prNo: '' ,
    combinedSlNo: '',
    fabricProjectionFormData: {},
    fabricprojectionInvocie:[]
   // fldSubject: '',  // Add fldSubject to the initial state
};

export let fabricProjectionReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_FABRIC_PROJECTION_REQUEST:
        case CREATE_FABRIC_PROJECTION_REQUEST:
        case UPDATE_FABRIC_PROJECTION_REQUEST:
        case FETCH_SINGLE_FABRIC_PROJECTION_REQUEST:
        case DELETE_FABRIC_PROJECTION_REQUEST:
        case FETCH_COMBINED_SL_NO_REQUEST:
        case FETCH_FABRIC_PROJECTION_INVOICE_REQUEST:
        case FETCH_PRNO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricProjectionList: updatePayload
            };

        case CREATE_FABRIC_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricProjectionForm: {
                    // fldFKUnitId:'',
                    // fldFKSupplierID: '',
                    fldGroupPRNo:'',
                    fldCombinedSlNo:'',
                    fldFKMillName:'',
                    //fldFKYarn:'',
                    fldFKFabric:'',
                    fldFKDia:'',
                    fldFKLoopLength:'',
                    fldFKGauge:'',
                    //fldBagWeight:'',
                    //fldNoofBags:'',
                     fldPRWeight:'',
                    fldRate:'',
                    fldRemarks:'',
                    fldGSM:'',
                    fldFKAgentName:'',
                    fldFKColor:'',
                    fldFabric:'',
                    fldColor:'',
                    fldDia:'',
                    fldLoopLegth:'',
                    fldGauge:''

                }
            };
        case FETCH_PRNO_SUCCESS:
            // Assuming updatePayload is the response array
           //const lastRecord = action.updatePayload[action.updatePayload.length - 1];
           
            return {
                ...state,
                // prNo: updatePayload.fldGroupPRNo,
                prNo: updatePayload,
              // fldSubject: lastRecord.fldSubject,  // Update fldSubject with the value from the last record
          
                loading: false
            };
            // subject validations 0407
            // case UPDATE_FLD_SUBJECT:
            // return {
            //     ...state,
            //     prNo: action.payload,
            // }; 
        case FETCH_COMBINED_SL_NO_SUCCESS:
            return {
                ...state,
                combinedSlNo: updatePayload,
                loading: false
            };
            case FETCH_FABRIC_PROJECTION_INVOICE_SUCCESS:
            return {
                ...state,
                fabricprojectionInvocie: updatePayload,
                loading: false
            };
        case UPDATE_FABRIC_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricProjectionForm: {}
            };
        case FETCH_SINGLE_FABRIC_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricProjectionForm: updatePayload
            };
        case DELETE_FABRIC_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricProjectionForm: {
                    // fldFKUnitId:'',
                    // fldFKSupplierID: '',
                    fldGroupPRNo:'',
                    fldCombinedSlNo:'',
                    fldFKMillName:'',
                    //fldFKYarn:'',
                    fldFKFabric:'',
                    fldFKDia:'',
                    fldFKLoopLength:'',
                    fldFKGauge:'',
                    //fldBagWeight:'',
                    //fldNoofBags:'',
                     fldPRWeight:'',
                    fldRate:'',
                    fldRemarks:'',
                    fldGSM:'',
                    fldFKAgentName:'',
                    fldFKColor:'',
                    fldFabric:'',
                    fldColor:'',
                    fldDia:'',
                    fldLoopLegth:'',
                    fldGauge:''

                }
            };
        case RESET_FABRIC_PROJECTION_INFO:
            return {
                ...state,
                fabricProjectionForm: {
                    // fldFKUnitId:'',
                    //fldFKSupplierID: '',
                    fldGroupPRNo:'',
                    fldCombinedSlNo:'',
                    fldFKMillName:'',
                    //fldFKYarn:'',
                    fldFKFabric:'',
                    fldFKDia:'',
                    fldFKLoopLength:'',
                    fldFKGauge:'',
                    //fldBagWeight:'',
                    //fldNoofBags:'',
                     fldPRWeight:'',
                    fldRate:'',
                    fldRemarks:'',
                    fldGSM:'',
                    fldFKAgentName:'',
                    fldFKColor:'',
                    fldFabric:'',
                    fldColor:'',
                    fldDia:'',
                    fldLoopLegth:'',
                    fldGauge:''

                },
                prNo:'',
                combinedSlNo:''
            };
        case CREATE_FABRIC_PROJECTION_FORM:
        case UPDATE_FABRIC_PROJECTION_FORM:
            return {
                ...state,
                loading: false,
                fabricProjectionForm: {
                    ...state.fabricProjectionForm,
                    [payload.key]: payload.value
                },
                fabricProjectionFormData: {
                    ...state.fabricProjectionFormData,
                    [payload.key]: payload.value
                },
            };
        case FETCH_FABRIC_PROJECTION_FAILURE:
        case CREATE_FABRIC_PROJECTION_FAILURE:
        case UPDATE_FABRIC_PROJECTION_FAILURE:
        case FETCH_SINGLE_FABRIC_PROJECTION_FAILURE:
        case DELETE_FABRIC_PROJECTION_FAILURE:
        case FETCH_PRNO_FAILURE:
        case FETCH_COMBINED_SL_NO_FAILURE:
        case FETCH_FABRIC_PROJECTION_INVOICE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
